import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Applique le thème enregistré avant le rendu (évite le flash)
try {
  if (localStorage.getItem("bl_theme") === "light") {
    document.documentElement.classList.add("light");
  }
} catch { /* */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
